<section>
  <app-player-basic-info [player]="player">
    <app-card-grid
      [cards]="cards"
    ></app-card-grid>
  </app-player-basic-info>
  <div class="graphs">
    <div class="figure-container middle-container">
      <app-spider-chart
        [data]="strengthAndWeaknessSpiderChartData"
      ></app-spider-chart>
    </div>
    <div class="figure-container middle-container">
      <app-donut-chart [data]="passDistributionData"></app-donut-chart>
    </div>
  </div>
  <div class="figure-container" style="width: 100%;">
    <app-line-chart
      [player]="player"
    ></app-line-chart>
  </div>
  <div class="tables">
    <div class="table-container">
      <p-table
        [value]="playerPerformanceLast5MatchesTableData"
        [tableStyle]="{ width: '100%' }"
        [classList]="[]"
        [size]="'large'"
        stripedRows
      >
        <ng-template #header>
          <tr>
            <th pSortableColumn="homeTeam">
              Partido <p-sortIcon field="homeTeam" />
            </th>
            <th pSortableColumn="goalScored">
              Goles <p-sortIcon field="goalScored" />
            </th>
            <th pSortableColumn="assists">
              Asistencias <p-sortIcon field="assists" />
            </th>
            <th pSortableColumn="turnovers">
              Perdidas <p-sortIcon field="turnovers" />
            </th>
            <th pSortableColumn="sanctions">
              Sanciones <p-sortIcon field="sanctions" />
            </th>
            <th pSortableColumn="minutesPlayed">
              Minutos Jugados <p-sortIcon field="minutesPlayed" />
            </th>
          </tr>
        </ng-template>
        <ng-template #body let-item>
          <tr>
            <td>{{ item.homeTeam }} vs {{ item.awayTeam }}</td>
            <td>{{ item.goalScored }}</td>
            <td>{{ item.assists }}</td>
            <td>{{ item.turnovers }}</td>
            <td>{{ item.sanctions }}</td>
            <td>{{ item.minutesPlayed }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</section>
